import { EntitiesStore } from './entities-store.abstract';

import { HttpClient } from '@angular/common/http';

import { Injector } from '@angular/core';

import { CountryDependencyEntityStore } from './country-dependency-entity-store';
import { filter, map, tap, withLatestFrom, combineLatest, distinctUntilChanged, pairwise } from 'rxjs/operators';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import * as rx from 'rxjs'
import { IPhotosCompetition } from './athlete-photos-store';
import { ComboStoreComponent, DateFilterStore, RangeDateFilterStore } from '../filters-store/filters-store';

/**
 * A class for get the events which have a event attached to some photo per athlete.
 *
 * @export
 * @class AthletePhotosEventsStore
 * @extends {EntitiesStore<IPhotosCompetition>}
 */
export class AthletePhotosEventsStore extends ComboStoreComponent<IPhotosCompetition> {

  /**
   * Range date for filter the events data.
   *
   * @type {RangeDateFilterStore}
   * @memberof AthletePhotosEventsStore
   */
  rangeDate: RangeDateFilterStore;

  /**
   * Creates an instance of AthletePhotosEventsStore.
   * @param {*} name_filter The name of the filter.
   * @param {HttpClient} http the http client.
   * @param {string} athlete_id The athlete id.
   * @memberof AthletePhotosEventsStore
   */
  constructor(name_filter, http: HttpClient, public athlete_id: string) {
    super(name_filter, 'name', 'events-photo-combo', undefined,
      undefined, http, undefined, [{ item: { name: 'All', id: undefined } as any, position: 0 }], [], true, 'event_name');
      this.filterInfo.options.only_on_init = true;
    this.rangeDate = new RangeDateFilterStore(
      "range_date",
      new DateFilterStore(
        "from",
        "From",
        undefined,
        undefined,
        new BehaviorSubject({ value: undefined }),
        undefined,
        new Date()
      ),
      new DateFilterStore(
        "to",
        "To",
        undefined,
        undefined,
        new BehaviorSubject({ value: new Date() }),
        undefined,
        new Date()
      )
    );
    this.filterInfo.options.hide_callback_change = new BehaviorSubject( (value) => {return true;});
    this.rangeDate.comboData.pipe(

      tap((rangeData)=>{
      if (rangeData.date_from || rangeData.date_to) {
        const func = (comp:any)=>{
          const date_from = rangeData.date_from ? (new Date(comp.date_start) > rangeData.date_from) : true;

          const date_to = rangeData.date_to ? (new Date(comp.date_end) < rangeData.date_to) : true;

          return date_from && date_to || comp.id == undefined;
        }
        this.filterInfo.options.hideDataCallback = func;
        this.filterInfo.options.hide_callback_change.next(func);
        const result = this.data.filter(func);
        this.filterInfo.options.options_subject.next(result);
        if(result.length === 1){
          this.filterInfo.options.options_selected_subject.next(result[0]);
        }
      }
    })).subscribe();
  }

  /**
   *
   * {@inheritdoc}
   * @returns {Observable<any>}
   * @memberof CompetitionsGalleryStore
   */
  getRequest(params: any, request_more: boolean = false): Observable<any> {
    this.loadingRef = true;
    return this.http.get(
      environment.drupal_api + (environment.photoEventsApi.replace('athlete_id', this.athlete_id)),
      {
        params: {}
      })
      .pipe(
        tap((next: IPhotosCompetition) => {
          const data = this.computeAllData(next as any);
          this.dataStream.next(data);
          this.data = data as any;
          this.filterInfo.options.options_subject.next(data);
          this.filterInfo.options.options_selected_subject.next(data[0]);
          this.loadingRef = false;
          this.requestMore = false;
        }));
  }

  /**
   * Method for compute all data with the extra options.
   *
   * @param {Array<IPhotosCompetition>} dataToSet The array from the api or filtered.
   * @returns
   * @memberof AthletePhotosEventsStore
   */
  computeAllData(dataToSet:Array<IPhotosCompetition>){
    if(dataToSet.length === 0){
      return [];
    }
    return  this.extraOptions.map(value=> value.item).concat(dataToSet);
  }
}
